import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '@environments/environment';

interface Metadata {
  title: string;
  description: string;
  relativeUrl: string;
  shouldIndex?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class SeoMetadataService {

  // https://stackoverflow.com/questions/48330535/dynamically-add-meta-description-based-on-route-in-angular
  // https://seoalive.com/meta-tags/

  constructor(
    private meta: Meta,
    private title: Title,
    @Inject(DOCUMENT) private dom: Document
  ) { }

  setMetadata(meta: Metadata) {

    this.title.setTitle(meta.title);
    this.meta.updateTag({ property: 'og:title', content: meta.title });

    this.meta.updateTag({ name: 'description', content: meta.description });
    this.meta.updateTag({ property: 'og:description', content: meta.description });

    const URL = `${environment.BASE_URL}${meta.relativeUrl}`;
    this.updateCanonicalUrl(URL);
    this.meta.updateTag({ property: 'og:url', content: URL });

    const robotsContent = meta.shouldIndex === false ? 'noindex, nofollow' : 'index, follow';
    this.meta.updateTag({ name: 'robots', content: robotsContent });
  }

  updateCanonicalUrl(url: string): void {
    let link: HTMLLinkElement | null = this.dom.querySelector("link[rel='canonical']");

    if (link) {
      link.setAttribute('href', url);
    } else {
      link = this.dom.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', url);
      this.dom.head.appendChild(link);
    }
  }

}
